<template>
  <div :id="id"></div>
  <img
    src="@/assets/images/pie-chart-bg.svg"
    alt="#"
    class="pie-chart-bg"
    v-if="theme == 'light'"
  />
  <img
    src="@/assets/images/pie-chart-bg.svg"
    alt="#"
    class="pie-chart-bg"
    v-if="theme == 'medium'"
  />
  <img
    src="@/assets/images/pie-chart-bg-dark.svg"
    alt="#"
    class="pie-chart-bg"
    v-if="theme == 'dark'"
  />
</template>

<script>
import store from "@/store";

import Highcharts from "highcharts";
import highchartsMore from "highcharts/highcharts-more";
import solidGauge from "highcharts/modules/solid-gauge";
highchartsMore(Highcharts);
solidGauge(Highcharts);

export default {
  name: "CircularPieV3",
  props: ["id", "data"],
  computed: {
    theme() {
      return store.getters.getCurrentTheme;
    },
    lang() {
      return store.getters.getCurrentLang;
    },
  },
  updated() {
   this.renderChart();
  },
  mounted() {
    this.renderChart();

  },
  methods: {
    renderChart: function () {
      Highcharts.chart(this.id, {
        chart: {
          backgroundColor: "transparent",
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
          height: "250px",
        },
        title: null,
        yAxis: [
          {
            min: 0,
            max: 10,
            lineWidth: 0,
            tickWidth: 0,
            minorTickInterval: null,
            tickPixelInterval: 200,
            labels: {
              y: -17,
              distance: 10,
              style: { fontSize: "0.4rem", color: "#41C9BB" },
            },
            title: {
              text: "Score",
              style: { color: "#859392", fontSize: "0.7rem" },
              y: 90,
            },
          },
          {
            linkedTo: 0,
            offset: -27,
            tickInterval: 0.4,
            tickLength: 2,
            tickColor: "#297971",
            tickWidth: 2,
            minorTickInterval: null,
            lineWidth: 0,
            labels: { enabled: !1 },
          },
        ],
        plotOptions: {
          pie: {
            borderWidth: 4,
            borderColor: this.theme == 'light' || this.theme == 'medium'? "#fff" : "#071D1D",
            center: ["50%", "50%"],
            allowPointSelect: true,
            cursor: "pointer",
            size: "60%",
            slicedOffset: 0,
            color: "red",
            fillColor: "red",
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}</b>",
              connectorColor: "silver",
              color: "#4a7780",
            },
          },
        },
        tooltip: {
          enabled: false,
          formatter: function () {
            return "<b>" + this.point.name + "</b>: " + this.y + " %";
          },
        },
        series: [
          {
            
            animation: {
              duration: 1500
            },
            data: [
              {
                name: "التنفیذ",
                y: this.data.executed,
                color: {
                  linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                  stops: [
                    [0, "#1B6371"], /// start
                    [1, "#AEF1FE"], // end
                  ],
                },
                dataLabels: {
                  connectorColor: this.theme=='light' || this.theme=='medium' ? "#90B2B9" : "#91B3BA",
                  distance: 10,
                  useHTML: true,
                  format:
                    this.theme == 'light' || this.theme =='medium' ? 
                    `<div class='cust-chart-datalabel' style='position:relative;color:#527A7A !important;'>التنفیذ <span class='cust-label' style='background-color:transparent;border:1px solid #00BABE;color:#153E39'>${this.data.executed}</span></div>` :
                    `<div class='cust-chart-datalabel' style='position:relative;color:#1B6371 !important;'>التنفیذ <span class='cust-label' style='background-color:#103C64;border:0px solid #1B6371;color:#fff'>${this.data.executed}</span></div>`
                    ,
                },
              },
              {
                name: "الإغلاق",
                y: this.data.closed,
                color: {
                  linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                  stops: [
                    [0, "#71C370"], /// start
                    [1, "#A1F3A0"], // end
                  ],
                },
                dataLabels: {
                  connectorColor: this.theme=='light' || this.theme=='medium' ? "#90B2B9" : "#91B3BA",
                  distance: 10,
                  useHTML: true,
                  format:
                    this.theme=='light' || this.theme =='medium' ? 
                    `<div class='cust-chart-datalabel' style='position:relative;color:#527A7A !important; '>الإغلاق <span class='cust-label left'style='background-color:transparent;border:1px solid #00BABE;color:#153E39'>${this.data.closed}</span></div>`:
                    `<div class='cust-chart-datalabel' style='position:relative;color:#1B6371 !important; '>الإغلاق <span class='cust-label left'style='background-color:#103C64;border:0px solid #1B6371;color:#fff'>${this.data.closed}</span></div>`
                    ,
                },
              },
              {
                name: "البدء",
                y: this.data.opened,
                color: {
                  linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                  stops: [
                    [0, "#5ACBE1"], /// start
                    [1, "#0090AD"], // end
                  ],
                },
                dataLabels: {
                  connectorColor:  this.theme=='light' || this.theme =='medium' ? "#90B2B9" : "#91B3BA",
                  distance: 10,
                  useHTML: true,
                  format:
                    this.theme == 'light' ||  this.theme == 'medium'?
                    `<div class='cust-chart-datalabel' style='position:relative;color:#527A7A !important;'>البدء <span class='cust-label left' style='background-color:transparent;border:1px solid #00BABE;color:#153E39'>${this.data.opened}</span></div>` : 
                    `<div class='cust-chart-datalabel' style='position:relative;color:#1B6371 !important;'>البدء <span class='cust-label left' style='background-color:#103C64;0px solid #1B6371;color:#fff'>${this.data.opened}</span></div>`
                    ,
                },
              },
              {
                name: "التخطيط",
                y: this.data.planned,
                color: {
                  linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                  stops: [
                    [0, "#5ACBE1"], /// start
                    [1, "#0090AD"], // end
                  ],
                },
                dataLabels: {
                  connectorColor:  this.theme=='light' || this.theme =='medium' ? "#90B2B9" : "#91B3BA",
                  distance: 10,
                  useHTML: true,
                  format:
                    this.theme == 'light' || this.theme =='medium'?
                    `<div class='cust-chart-datalabel' style='position:relative;color:#527A7A !important;'>التخطيط <span class='cust-label left' style='background-color:transparent;border:1px solid #00BABE;color:#153E39'>${this.data.planned}</span></div>` : 
                    `<div class='cust-chart-datalabel' style='position:relative;color:#1B6371 !important;'>التخطيط <span class='cust-label left' style='background-color:#103C64;0px solid #1B6371;color:#fff'>${this.data.planned}</span></div>`
                    ,
                },
              },
            ],
            size: "65%",
            innerSize: "75%",
            showInLegend: false,
            dataLabels: {
              enabled: true,
            },
          },
        ],
      });
      document
      .querySelectorAll(".highcharts-credits")
      .forEach((item) => (item.style.display = "none"));
    },

  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";
body.theme-light {
  .pie-chart-bg {
    position: absolute;
    top: 149px;
    z-index: 0;
  }
  #cirpie1,
  #cirpie2,
  #cirpie3,
  #cirpie4 {
    width: 380px !important;
    height: 250px !important;
    margin-top: 18px;
  }
}
body.theme-medium {
  .pie-chart-bg {
    position: absolute;
    top: 149px;
    z-index: 0;
  }
  #cirpie1,
  #cirpie2,
  #cirpie3,
  #cirpie4 {
    width: 380px !important;
    height: 250px !important;
    margin-top: 18px;
  }
}
body.theme-dark {
  .pie-chart-bg {
    position: absolute;
    top: 149px;
    z-index: 0;
  }
  #cirpie1,
  #cirpie2,
  #cirpie3,
  #cirpie4 {
    width: 380px !important;
    height: 250px !important;
    margin-top: 18px;
  }
}
</style>